export const SC_FORBIDDEN_PAGES = [
  '/offers',
  '/checkout',
  '/luxe-club',
  '/promotions',
  '/coin-store',
  '/redeem',
];